export type VoiceAlias = {
  from: string;
  to: string;
};

export const VOICE_SEARCH_ALIASES: VoiceAlias[] = [
  { from: 'vê gờ a', to: 'vga' },
  { from: 've go a', to: 'vga' },
  { from: 'v g a', to: 'vga' },
  { from: 'vi gờ a', to: 'vga' },
  { from: 'rờ tê ích', to: 'rtx' },
  { from: 'r t x', to: 'rtx' },
  { from: 'ạc ti ích', to: 'rtx' },
  { from: 'ác ti ích', to: 'rtx' },
  { from: 'a ti ích', to: 'rtx' },
  { from: 'gờ tê ích', to: 'gtx' },
  { from: 'g t x', to: 'gtx' },
  { from: 'co i ba', to: 'core i3' },
  { from: 'core i ba', to: 'core i3' },
  { from: 'co i3', to: 'core i3' },
  { from: 'co i năm', to: 'core i5' },
  { from: 'core i năm', to: 'core i5' },
  { from: 'co i5', to: 'core i5' },
  { from: 'co i bảy', to: 'core i7' },
  { from: 'core i bảy', to: 'core i7' },
  { from: 'co i7', to: 'core i7' },
  { from: 'co i chín', to: 'core i9' },
  { from: 'core i chín', to: 'core i9' },
  { from: 'co i9', to: 'core i9' },
  { from: 'rai dần ba', to: 'ryzen 3' },
  { from: 'rai dần năm', to: 'ryzen 5' },
  { from: 'rai dần bảy', to: 'ryzen 7' },
  { from: 'rai dần chín', to: 'ryzen 9' },
  { from: 'rai zen ba', to: 'ryzen 3' },
  { from: 'rai zen năm', to: 'ryzen 5' },
  { from: 'rai zen bảy', to: 'ryzen 7' },
  { from: 'rai zen chín', to: 'ryzen 9' },
  { from: 'mười hai ngàn bảy trăm ca ép', to: '12700kf' },
  { from: 'mười hai ngàn bảy trăm k f', to: '12700kf' },
  { from: 'mười hai ngàn bảy trăm ca', to: '12700k' },
  { from: 'mười hai ngàn bảy trăm', to: '12700' },
  { from: 'mười hai ngàn sáu trăm ca ép', to: '12600kf' },
  { from: 'mười hai ngàn sáu trăm k f', to: '12600kf' },
  { from: 'mười hai ngàn sáu trăm ca', to: '12600k' },
  { from: 'mười hai ngàn sáu trăm ép', to: '12600f' },
  { from: 'mười hai ngàn sáu trăm', to: '12600' },
  { from: 'mười hai ngàn bốn trăm ca ép', to: '12400kf' },
  { from: 'mười hai ngàn bốn trăm k f', to: '12400kf' },
  { from: 'mười hai ngàn bốn trăm ép', to: '12400f' },
  { from: 'mười hai ngàn bốn trăm', to: '12400' },
  { from: 'mười hai ngàn một trăm ép', to: '12100f' },
  { from: 'mười hai ngàn một trăm', to: '12100' },
  { from: 'mười ba ngàn chín trăm ca ép', to: '13900kf' },
  { from: 'mười ba ngàn chín trăm k f', to: '13900kf' },
  { from: 'mười ba ngàn chín trăm ca', to: '13900k' },
  { from: 'mười ba ngàn chín trăm', to: '13900' },
  { from: 'bốn không bảy không ti', to: '4070 ti' },
  { from: 'bốn nghìn không trăm bảy mươi ti', to: '4070 ti' },
  { from: 'bốn không bảy mươi ti', to: '4070 ti' },
  { from: 'bốn không bảy không', to: '4070' },
  { from: 'bốn nghìn không trăm bảy mươi', to: '4070' },
  { from: 'bốn không bảy mươi', to: '4070' },
  { from: 'bốn không sáu không ti', to: '4060 ti' },
  { from: 'bốn không sáu mươi ti', to: '4060 ti' },
  { from: 'bốn không sáu không', to: '4060' },
  { from: 'bốn không sáu mươi', to: '4060' },
  { from: 'ba không sáu không ti', to: '3060 ti' },
  { from: 'ba không sáu mươi ti', to: '3060 ti' },
  { from: 'ba nghìn không trăm sáu mươi ti', to: '3060 ti' },
  { from: 'ba không sáu không', to: '3060' },
  { from: 'ba không sáu mươi', to: '3060' },
  { from: 'ba nghìn không trăm sáu mươi', to: '3060' },
  { from: 'ca ép', to: 'kf' },
  { from: 'k ép', to: 'kf' },
  { from: 'k f', to: 'kf' },
  { from: 'ca', to: 'k' },
  { from: 'ép', to: 'f' },
  { from: 'main bo', to: 'mainboard' },
  { from: 'men bo', to: 'mainboard' },
  { from: 'bo mạch chủ', to: 'mainboard' },
  { from: 'răm', to: 'ram' },
  { from: 'ét ét đi', to: 'ssd' },
  { from: 's s d', to: 'ssd' },
  { from: 'hát đê đê', to: 'hdd' },
  { from: 'h d d', to: 'hdd' },
  { from: 'nguồn', to: 'psu' },
  { from: 'p s u', to: 'psu' },
  { from: 'pi ét diu', to: 'psu' },
  { from: 'thùng máy', to: 'case' },
  { from: 'vỏ case', to: 'case' },
  { from: 'tản nhiệt nước', to: 'tản nhiệt' },
  { from: 'tản nhiệt khí', to: 'tản nhiệt' },
  { from: 'ba mươi hai ghi', to: '32gb' },
  { from: 'mười sáu ghi', to: '16gb' },
  { from: 'tám ghi', to: '8gb' },
  { from: 'một tép', to: '1tb' },
  { from: 'hai tép', to: '2tb' },
  { from: 'hai trăm bốn mươi', to: '240' },
  { from: 'bảy trăm năm mươi oát', to: '750w' },
  { from: 'em ét ai', to: 'msi' },
  { from: 'a sút', to: 'asus' },
  { from: 'át rốc', to: 'asrock' },
  { from: 'át rock', to: 'asrock' },
  { from: 'ghi ga bai', to: 'gigabyte' },
  { from: 'ghi ga byte', to: 'gigabyte' },
];

function normalizeVoiceText(value: string) {
  return String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd')
    .replace(/[^a-z0-9\s./+-]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function escapeRegExp(value: string) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

const SORTED_ALIASES = VOICE_SEARCH_ALIASES.map((alias) => ({
  from: normalizeVoiceText(alias.from),
  to: alias.to,
})).sort((a, b) => b.from.length - a.from.length);

export function normalizeVoiceSearchQuery(value: string) {
  let normalized = ` ${normalizeVoiceText(value)} `;

  for (const alias of SORTED_ALIASES) {
    normalized = normalized.replace(
      new RegExp(`\\s${escapeRegExp(alias.from)}\\s`, 'g'),
      ` ${alias.to} `
    );
  }

  return normalized
    .replace(/\bcore\s+i\s*([3579])\b/g, 'core i$1')
    .replace(/\brtx\s*(\d{4})\s*ti\b/g, 'rtx $1 ti')
    .replace(/\brtx\s*(\d{4})\b/g, 'rtx $1')
    .replace(/\bgtx\s*(\d{4})\b/g, 'gtx $1')
    .replace(/\s+/g, ' ')
    .trim();
}
